import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import './utils/directive' //自定义指令





// import './config/rem'
import YDUI from 'vue-ydui'
import 'vue-ydui/dist/ydui.rem.css'
import 'vue-ydui/dist/ydui.flexible.js'
import "./assets/css/common.css"
import "./assets/css/common.scss"
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'
import Vant from 'vant'
// 全局注册
Vue.use(Vant)


Vue.config.ignoredElements = ['wx-open-launch-weapp']
import store from './store'

import App from './App'
// import router from './router'
import router from './utils/home'
import axios from 'axios'
import {
	DateTime
} from 'vue-ydui/dist/lib.rem/datetime'

// import VueHtml5Editor from 'vue-html5-editor'
import 'font-awesome/css/font-awesome.min.css'

import Viewer from 'v-viewer'
import '@/assets/css/viewer.css'
import {
	wechatGetUserInfo,
	userGetUserInfo,
	wechatJssdk,
	oauthToken
} from '@/api/main'

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)


import 'vant/lib/index.css'

// 引入基础样式表
import './assets/css/base.css'

import * as _ from 'lodash'
Vue.prototype._ = _

import {
	Toast
} from 'vant'
Vue.prototype.$toast = Toast

import {
	Dialog
} from 'vant'
Vue.prototype.$Dialoga = Dialog

Vue.use(Viewer)
Viewer.setDefaults({
	Options: {
		'inline': true,
		'button': true,
		'navbar': true,
		'title': true,
		'toolbar': true,
		'tooltip': true,
		'movable': true,
		'zoomable': true,
		'rotatable': true,
		'scalable': false,
		'transition': true,
		'fullscreen': true,
		'keyboard': false,
		'url': 'data-source'
	}
})

import wx from 'weixin-js-sdk'
import global_ from './components/Global'
import VueClipboard from 'vue-clipboard2'
import animate from 'animate.css'

//调试 线上注销
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// export default vConsole


Vue.use(VueClipboard)
Vue.use(animate)

Vue.use(YDUI)
Vue.component(DateTime.name, DateTime)
Vue.prototype.$axios = axios
Vue.prototype.GLOBAL = global_
Vue.prototype.bus = new Vue
Vue.prototype.$store = store



router.beforeEach((to, from, next) => {
	let historyList = store.state.historyList
	let {
		isBack,
		backRenovate
	} = store.state
	let homeList = ['jiGou', 'woDe', 'homeNew', 'gallerySelResult']
	let homeIndex = homeList.indexOf(to.name)
	// console.log(11111,to,from,historyList);
	if (from.name != null) {
		let toIndex = historyList.indexOf(to.name);
		let fromIndex = historyList.indexOf(from.name);
		if (isBack == 1) {
			historyList = historyList.filter(item => item != from.name)
			if (backRenovate == 1) {
				historyList = historyList.filter(item => item != to.name)
				store.commit('editBackRenovate', 0)
			}
		} else {
			if (fromIndex == -1) historyList.push(from.name)
			if (toIndex == -1) historyList.push(to.name)
			if (homeIndex != -1) {
				historyList = []
			} else {
				if (toIndex != -1) historyList = historyList.filter(item => item != to.name)
			}
		}
	} else {
		historyList = []
	}
	store.commit('editIsBack', 0)
	store.commit('editHistoryList', historyList)
	window._axiosPromiseArr && window._axiosPromiseArr.forEach((ele, index) => {
		ele.cancel() // 路由跳转之前，清空（终止）上一个页面正在请求的内容
		// 清空请求的参数 清空请求的参数
		delete window._axiosPromiseArr[index]
	})

	const getQuery = name => {
		var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
		var r = window.location.search.substr(1).match(reg)
		if (r != null) {
			if (name == 'back_uri' && (r.input.indexOf('pay/gallery_work_details?work_id=') > -1 || r.input.indexOf(
					'pay/only_school_activity_details?activity_id=') > -1)) {
				var urlstring = r.input.replace('back_uri=', '')
				return unescape(urlstring)
			} else {
				return unescape(r[2])
			}
		}
		return null
	}

	// 微信 OAuth 回调带 state=123；与测评等业务链接中的 code 参数区分（避免把测评 share_code 当成微信 code）
	const getWechatOAuthCode = () => {
		if (getQuery('state') !== '123') return null
		const search = window.location.search.substr(1)
		if (!search) return null
		let lastCode = null
		search.split('&').forEach((part) => {
			const eq = part.indexOf('=')
			if (eq === -1) return
			const key = part.slice(0, eq)
			const val = part.slice(eq + 1)
			if (key === 'code' && val) {
				try {
					lastCode = decodeURIComponent(val.replace(/\+/g, ' '))
				} catch (e) {
					lastCode = val
				}
			}
		})
		return lastCode
	}

	const assessmentEntryRouteNames = [
		'assessmentOrgDetail',
		'assessmentParentDetail',
		'assessmentParentEnroll'
	]

	const restoreAssessmentEntryRoute = (routeTo) => {
		if (assessmentEntryRouteNames.indexOf(routeTo.name) === -1) return null
		const editfromUrl = localStorage.getItem('editfromUrl')
		if (!editfromUrl) return null
		try {
			const saved = new URL(editfromUrl)
			const savedPath = saved.pathname.replace(/\/+$/, '')
			const currentPath = routeTo.path.replace(/\/+$/, '')
			if (savedPath !== currentPath) return null
			const query = {}
			saved.searchParams.forEach((val, key) => {
				if (key !== 'state' && key !== 'code') query[key] = val
			})
			const shareCode = saved.searchParams.get('share_code')
			if (!shareCode) return null
			query.share_code = shareCode
			return { path: routeTo.path, query, replace: true }
		} catch (e) {
			return null
		}
	}

	var wechatOAuthCode = getWechatOAuthCode()
	var back_uri = getQuery('back_uri') //平台设置回调地址
	var redirect_uri = encodeURIComponent(window.location.href)
	if (back_uri != null) {
		redirect_uri = encodeURIComponent(back_uri)
	}
	// 此路由可以在浏览器打开
	if (to.name == 'GalleryLive' || to.name == 'ce' || to.name == 'tu' || to.name == 'LiveEntry' || to.name == 'goldPlanReceipt') {
		next()
	} else {
		//请求token
		if (localStorage.getItem('user_access_token') == null ||
			localStorage.getItem('user_access_token') == '' ||
			localStorage.getItem('user_access_token') == undefined ||
			localStorage.getItem('user_access_token') == 'undefined'
		) {
			getToken()
		} else {
			if (back_uri != null) {
				window.location.href = back_uri
			}
			next()
		}
	}
	//获取token
	async function getToken() {
		if (wechatOAuthCode == null) {
			// 保存返回链接 （分享进来的话第一次进入跳转分享页面）
			const entryShareCode = to.query && to.query.share_code
			if (assessmentEntryRouteNames.indexOf(to.name) !== -1 && entryShareCode) {
				localStorage.setItem('editfromUrl', window.location.href.split('#')[0])
			} else if (!localStorage.getItem('editfromUrl') ||
				localStorage.getItem('editfromUrl') == null ||
				localStorage.getItem('editfromUrl') == '') {
				localStorage.setItem('editfromUrl', window.location.href)
			}
			
			window.location =
				`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${global_.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
		} else {
			Vue.prototype.$dialog.loading.open('正在初始化...')
			try {
				const wechatData = await wechatGetUserInfo({
					code: wechatOAuthCode
				})
				if (!wechatData) {
					Vue.prototype.$dialog.loading.close()
					Vue.prototype.$dialog.toast({
						mes: '获取权限失败',
						timeout: 3000
					})
					localStorage.removeItem('editfromUrl')
					next()
					return
				}
				localStorage.setItem('user_access_token', wechatData)
				const {
					data: userData
				} = await userGetUserInfo({})
				localStorage.setItem('id', userData.id)
				localStorage.setItem('mobile', userData.mobile)
				localStorage.setItem('openid', userData.openid)
				localStorage.setItem('current_user_name', userData.name == null ? userData.nickname : userData.name)
				if (!localStorage.getItem('current_student_id') && userData.student_id) {
					localStorage.setItem('current_student_id', userData.student_id)
				}
				if (userData.school_info && userData.school_info.id && !localStorage.getItem('current_school_id')) {
					localStorage.setItem('current_school_id', userData.school_info.id)
				}
				//获取客户端token
				var formData = new FormData()
				formData.append('grant_type', 'client_credentials')
				formData.append('client_id', 2)
				formData.append('client_secret', 'U0voXrrQueaShxSZByQPxTDVv4R9A2UGGxF3EwV9')
				formData.append('scope', '*')
				const oauthData = await oauthToken(formData)
				localStorage.setItem('client_access_token', oauthData.access_token)
				Vue.prototype.$dialog.loading.close()
				const restoredRoute = restoreAssessmentEntryRoute(to)
				if (restoredRoute) {
					next(restoredRoute)
				} else {
					next()
				}
			} catch (e) {
				Vue.prototype.$dialog.loading.close()
				Vue.prototype.$dialog.toast({
					mes: '获取权限失败',
					timeout: 3000
				})
				next()
			}
		}
	}
	//设置标题
	if (to.meta.title) {
		document.title = to.meta.title
	}
})

router.afterEach(async (to, from) => {
	// 与 beforeEach 白名单一致：非微信内嵌 / 点金小票等无需 jssdk，避免 /api/wechat/jssdk 500 导致 Uncaught (in promise)
	const skipWechatJssdk = ['GalleryLive', 'ce', 'tu', 'LiveEntry', 'goldPlanReceipt']
	if (skipWechatJssdk.indexOf(to.name) !== -1) {
		return
	}

	var _url = window.location.origin + to.fullPath
	let jsApiList = [
		'chooseImage',
		'uploadImage',
		'downloadImage',
		'getLocalImgData',
		'chooseWXPay',
		'getLocation',
		'scanQRCode',
		'openLocation',
		'updateAppMessageShareData',
		'updateTimelineShareData',
		'checkJsApi',
		'hideAllNonBaseMenuItem',
		'showMenuItems',
		'startRecord',
		'stopRecord',
		'onVoiceRecordEnd',
		'playVoice',
		'pauseVoice',
		'stopVoice',
		'onVoicePlayEnd',
		'uploadVoice',
		'downloadVoice',
	]
	let openTagList = [
		'wx-open-launch-weapp'
	]
	const ua = (navigator.userAgent || '').toLowerCase()
	const isHarmonyNext = ua.indexOf('openharmony') !== -1 || (ua.indexOf('harmonyos') !== -1 && ua.indexOf('android') === -1)
	// iOS / 纯血鸿蒙：用当前完整 url 签名，否则开放标签点击会失败
	if (window.__wxjs_is_wkwebview === true || isHarmonyNext) {
		_url = window.location.href.split('#')[0]
	}

	try {
		const {
			appId,
			timestamp,
			nonceStr,
			signature
		} = await wechatJssdk({
			url: _url,
			jsApiList
		})
		wx.config({
			debug: false,
			appId,
			timestamp,
			nonceStr,
			signature,
			jsApiList,
			openTagList
		})
		wx.ready(() => {
			Vue.prototype.bus.$emit('wxConfigReady')
		})
	} catch (e) {
		console.warn('wechat jssdk 跳过或失败', to.name, e)
	}
})
new Vue({
	el: '#app',
	router,
	render: h => h(App),
})


// WEBPACK FOOTER //
// ./src/main.js